import Image, { StaticImageData } from "next/image";
import CommonTitle from "../common/CommonTitle";
import CommonSubtitle from "../common/CommonSubtitle";
import workAiImage from "@/assets/images/ai/ai-agent/work-ai-agents.svg";


export type WorkAiType = {
  contextualTag: string;
  title: React.ReactNode;
  description?: string;
  image: StaticImageData;
};

export const defaultWorkAi: WorkAiType = {
  contextualTag: "The Squad",
  title: <>Meet your new{" "}
    <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
      AI Team.
    </span></>,
  description:
    "Use pre-built agents or build your own from scratch.",
  image: workAiImage as StaticImageData,
} as const;

const WorkAi = ({ workAiInfo = defaultWorkAi, isBgTransparent = false }: { workAiInfo?: WorkAiType, isBgTransparent?: boolean, }) => {
  const { contextualTag, title, description, image } = workAiInfo;
  return (
    <section className={`${isBgTransparent ? "bg-transparent" : "bg-white"} pt-12 xl:pt-20`}>
      <div className="container mx-auto px-4">
        <div className="text-center">
          <div className="mx-auto mb-2 inline-flex w-fit rounded-full bg-[#F3F3F3] px-3 py-1 text-sm font-semibold">
            <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
              {contextualTag}
            </span>
          </div>
          <CommonTitle
            as="h2"
            fontWeightClass="font-semibold"
            color="#202020"
            fontSizeClass="text-[24px] lg:text-[32px] mb-4"
          >
            {title}
          </CommonTitle>
          {description && <CommonSubtitle
            color="#202020"
            fontSizeWeight="text-[14px] lg:text-[16px] font-normal max-w-[900px] mx-auto"
          >
            {description}
          </CommonSubtitle>}
        </div>
      </div>
      <div className="relative w-full"
      >
        <Image src={image} alt="Kroolo AI agents team - Pre-built and custom AI assistants" width={1000} height={1000} className="w-full h-full object-contain" draggable={false} />
      </div>
    </section>
  );
};

export default WorkAi;
